export const headers = [
    { label: 'Report Date', key: 'date' },
    { label: 'Developer Name', key: 'userName' },
    { label: 'Project Name', key: 'projectName' },
    { label: 'Report Title', key: 'reportTitle' },
    { label: 'Report Description', key: 'description' },
    { label: 'Report Time', key: 'reportTime' }
];
